import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ITask } from '@fi-shared/fi-task-shared/fi-task-shared';

@Component({
    selector: 'fi-tasks-archived-container',
    template: ` <fi-tasks-archived [tasks]="tasks"> </fi-tasks-archived> `,
    styleUrls: ['./tasks-archived-container.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-tasks-archived-container' },
    standalone: false,
})
export class TasksArchivedContainerComponent implements OnInit {
    @Input() tasks: ITask[];

    constructor() {}

    ngOnInit() {}
}
